import { Form, Input, Select } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import React from 'react';
import CustomButton from 'components/custom-button';
import { TYPE_SOUND } from '../../../constants/common';

const initialValues = {
  name: '',
  type: '',
};
const { Option } = Select;

const Filter: React.FC<any> = (props) => {
  const [form] = Form.useForm();
  const { onSubmit } = props;

  const onClearFilter = () => {
    form.resetFields();
    onSubmit({ ...form.getFieldsValue() });
  };

  const onFormSubmit = (value: typeof initialValues) => {
    const { ...rest } = value;

    onSubmit({ ...rest });
  };

  return (
    <Form
      form={form}
      name="register"
      layout="inline"
      onFinish={onFormSubmit}
      initialValues={initialValues}
      style={{ rowGap: 12 }}
    >
      <Form.Item name="name">
        <Input placeholder="Tên âm thanh" allowClear style={{ width: 220 }} />
      </Form.Item>
      <Form.Item name="type">
        <Select style={{ width: 180 }}>
          {/* "" = không lọc theo loại (giá trị mặc định cũ của bộ lọc). */}
          <Option value="">Tất cả loại</Option>
          <Option value={TYPE_SOUND.SOUND_EFFECT}>Hiệu ứng</Option>
          <Option value={TYPE_SOUND.MUSIC}>Âm thanh</Option>
          <Option value={TYPE_SOUND.PAY_THE_BET}>Trả kèo</Option>
          <Option value={TYPE_SOUND.SYNTHETIC}>Tổng hợp</Option>
        </Select>
      </Form.Item>
      <Form.Item>
        <CustomButton
          bgColor="secondary-green"
          htmlType="submit"
          text="Tìm kiếm"
          icon={<SearchOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <CustomButton
          text="Xóa lọc"
          bgColor="primary-grey"
          icon={<CloseOutlined />}
          onClick={onClearFilter}
        />
      </Form.Item>
    </Form>
  );
};

export default Filter;
